(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4545,1674],{

/***/ 115979:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-status/[hash]",
      function () {
        return __webpack_require__(114624);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 114624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331399);
/* harmony import */ var _containers_OrderStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(533350);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(268037);
/**
 * Order Status Screen
 */ 






var OrderStatusPage = function(props) {
    var ref, ref1;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: "Orders - Now Shop Online",
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image,
        metaDescription: "Now order online from my whatsapp store & pay using 150+ UPI Apps",
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_OrderStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (OrderStatusPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,8388,1562,4814,6576,7779,1033,1399,3978,3973,8557,7909,719,736,9774,2888,179], function() { return __webpack_exec__(115979); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);